import { ICON_NAMES } from '@/config/config';

import { MerchantVertical } from './getMerchantVerticalByMerchantCategory';

export const getIconByMerchantVertical = (merchantVertical: MerchantVertical) => {
  switch (merchantVertical) {
    case MerchantVertical.AUTO:
      return ICON_NAMES.AUTO;
    case MerchantVertical.EDUCATION:
      return ICON_NAMES.EDUCATION;
    case MerchantVertical.HEALTH:
      return ICON_NAMES.HEALTH;
    case MerchantVertical.HOME:
      return ICON_NAMES.HOME;
    case MerchantVertical.INSTALLATION:
      return ICON_NAMES.INSTALLATION;
    case MerchantVertical.MOBILITY:
      return ICON_NAMES.MOBILITY;
    case MerchantVertical.NULL:
      return 'shopping_cart';
    case MerchantVertical.OTHERS:
      return ICON_NAMES.OTHERS;
    case MerchantVertical.RETAIL:
      return ICON_NAMES.RETAIL;
    case MerchantVertical.TRAVEL_AND_LEISURE:
      return ICON_NAMES.FLIGHT;
  }
};
